import axios from 'axios';

import { getReasonPhrase, StatusCodes } from 'http-status-codes';

export class Bcp {
  http;

  constructor() {
    this.http = axios.create({
      baseURL: `https://newprod-api.bestcoastpairings.com/v1/`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'client-id': 'web-app',
        'env': 'bcp',
      },
      
    });
  }

  handleResponse = (res, refreshRequest = false) => {
    if (
      res.status !== (StatusCodes.OK || StatusCodes.NO_CONTENT) &&
      res.statusText !== (getReasonPhrase(StatusCodes.OK) || getReasonPhrase(StatusCodes.NO_CONTENT))
    ) {
      if (res.status === StatusCodes.FORBIDDEN || res.status === StatusCodes.UNAUTHORIZED) {
        if (!refreshRequest && res.data?.code === 'verlopen') {
          return this.refreshFunc().then(() => {
            return this.request(res.config, true);
          });
        } else {
          throw new Error('U bent niet geautoriseerd', res.status, res.data);
        }
      } else {
        throw new Error(`Request rejected with status ${res.status}`, res.status, res.data);
      }
    }
    return res.data;
  };

  setRefreshFunc = (refreshFunc) => {
    this.refreshFunc = refreshFunc;
  };

  setToken = (token) => {
    this.token = token;

    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = `Bearer ${this.token}`;
      return config;
    });
  };

  request = async (config, refreshRequest) => {
    try {
      const res = await this.http.request(config);
      return res.data;
    } catch ({ response: res }) {
      return this.handleResponse(res, refreshRequest);
    }
  };

  get = async (path, headers, params) => {
    try {
      const res = await this.http.get(`${path}`, { headers, params });
      return res.data;
    } catch ({ response: res }) {
      return this.handleResponse(res);
    }
  };
}

export const bcp = new Bcp();
